import React, { useState, useEffect, useCallback } from "react";
import Accounts from "./Accounts";
import Logo from "./Logo";
import Navigation from "./Navigation";
import { HeaderStyle } from "../styles/header.style";
import classNames from "classnames";

const Header = ({ activeNav, handleNavSelect }) => {
  const navHover =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627792/mad_wallet/images/nav_hover.png";

  const [menuToggle, setMenuToggle] = useState(false);
  const [screenSize, setScreenSize] = useState("desktop");

  const handleResize = useCallback(() => {
    setScreenSize(handleLayoutMode);
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  const handleLayoutMode = () =>
    window.innerWidth > 768 ? "desktop" : "mobile";

  const handleMenuToggle = () => setMenuToggle(!menuToggle);

  const closeMenu = () => setMenuToggle(false);

  return (
    <HeaderStyle
      bg={navHover}
      className={classNames("mdw__main-header", {
        'open': menuToggle && screenSize === "mobile",
      })}
    >
      <Logo section="header" />
      <Navigation
        activeNav={activeNav}
        screenSize={screenSize}
        menuToggle={menuToggle}
        onNavSelect={handleNavSelect}
        onNavClose={closeMenu}
      />
      <Accounts
        screenSize={screenSize}
        menuToggle={menuToggle}
        onToggleMenu={handleMenuToggle}
      />
    </HeaderStyle>
  );
};

export default Header;
